export var SlavicLanguages = ['uk', 'ru', 'pl', 'cz'];
//# sourceMappingURL=ExpandedEventUtilsConstants.js.map